import styled from "styled-components";

export const Body = styled.div`
    display: block;
    width: 100%;
    height: calc(100% - 82px);
    background-color: white;
    padding: 0px 28px 28px;
`;

export const ClientHeader = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;
    line-height: 1;
`;

export const ClientInfo = styled.div`
    p {
        font-size: 16px;
        margin-bottom: 4px;
        color: ${props => props.theme.colors.textPrimary};
    }
    span{
        font-size: 14px;
        color: ${props => props.theme.colors.textPrimary};
    }
`;
